import type { ReactNode } from 'react'
import { Checkbox } from '../Checkbox/Checkbox'
import { cx } from '../utils/cx'
import './Checklist.css'

export interface ChecklistItem {
  id: string
  label: ReactNode
  done: boolean
}

export interface ChecklistProps {
  items: ChecklistItem[]
  onToggle: (id: string, done: boolean) => void
  className?: string
}

/** Lista de comprobación (bundle B7): filas de 64 px con casilla de 24 px (radio 6); marcada en success. */
export function Checklist({ items, onToggle, className }: ChecklistProps) {
  return (
    <ul className={cx('hp-checklist', className)}>
      {items.map((it) => (
        <li key={it.id} className="hp-checklist__row">
          <Checkbox checked={it.done} onChange={(done) => onToggle(it.id, done)} tone="success" large className="hp-checklist__check">
            {it.label}
          </Checkbox>
        </li>
      ))}
    </ul>
  )
}
